// extracted by mini-css-extract-plugin
export default {"iframe":"Lihsrz","screenWidth":"Xf7R3u"};